<template>
    <v-modal-validated title="Añadir un nuevo expediente"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       :do-close-on-accept="false"
                       id="add-expedients-modal"
                       :rules="rules"
                       @closed="closeModal"
                       @accepted="addExpedient">
        <div class="form-container">
            <div class="user-form row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Nombre: </label>
                        <Field type="text" name="name" class="form-control" aria-label="Nombre"
                               v-model="expedient.name"/>

                        <ErrorMessage name="name"/>
                    </div>
                </div>
            </div>

            <div class="user-form row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="form-label">Tipo de contrato: </label>
                        <Field type="text" name="contract_type" class="form-control" aria-label="contract_type" v-model="expedient.contract_type">
                            <select class="form-select" name="contract_type" aria-label="Tipo" v-model="expedient.contract_type">
                                <option :value="contract_type.key" :key="contract_type.id" v-for="contract_type in contractTypes">
                                    {{ contract_type.value }}
                                </option>
                            </select>
                        </Field>

                        <ErrorMessage name="contract_type"/>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="user-form">
                        <div class="form-group">
                            <label for="entity_id">Entidades: </label>
                            <select class="form-control" disabled v-if="entitiesOptions.length === 0">
                                <option selected>- No existen entidades en la aplicación -</option>
                            </select>

                            <Field type="text" id="entity_id" name="entity_id" class="form-control"
                                   v-model="expedient.entity_id"
                                   v-if="entitiesOptions.length !== 0">

                                <v-select-jq aria-label="Entidad"
                                             parent-id="add-expedients-modal"
                                             placeholder="- Seleccionar -"
                                             :options="entitiesOptions"
                                             :modelValue="expedient.entity_id"
                                             @update:modelValue="expedient.entity_id = $event">
                                </v-select-jq>
                            </Field>

                            <ErrorMessage name="entity_id"/>
                        </div>
                    </div>

                    <div class="extra-data" v-for="entity in entities">
                        <div v-if="entity.id == expedient.entity_id">
                            <span class="badge bg-dark">{{ entity.nif }}</span>&nbsp;
                            <span class="badge bg-secondary">{{ entity.name }} ({{ entity.short_name }})</span>&nbsp;

                            <a class="badge text-black-50" :href="'mailto:' + entity.email_01" v-if="!!entity.email_01">
                                <i class="uq-icon bi-mailbox"></i>&nbsp;{{ entity.email_01 }}
                            </a>
                            <a class="badge text-black-50" :href="'tel:' + entity.customer_service_number_phone"
                               v-if="!!entity.customer_service_number_phone">
                                <i class="uq-icon bi-phone"></i>&nbsp;{{ entity.customer_service_number_phone }}
                            </a>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="user-form">
                        <div class="form-group">
                            <label>Clientes: </label>
                            <select class="form-control" disabled v-if="clientsOptions.length === 0">
                                <option selected>- No existen clientes en la aplicación -</option>
                            </select>

                            <Field type="text" name="client_id" class="form-control"
                                   v-model="expedient.client_id"
                                   v-if="clientsOptions.length !== 0">

                                <v-select-jq aria-label="Cliente"
                                             parent-id="add-expedients-modal"
                                             placeholder="- Seleccionar -"
                                             :options="clientsOptions"
                                             :value="expedient.client_id"
                                             @update:modelValue="expedient.client_id = $event">
                                </v-select-jq>
                            </Field>

                            <ErrorMessage name="client_id"/>
                        </div>
                    </div>

                    <div class="extra-data" v-for="client in clients">
                        <div v-if="client.id == expedient.client_id">
                            <div>
                                <span class="badge bg-dark">#{{ client.code }}</span>&nbsp;
                                <span class="badge bg-secondary">{{ client.name }} {{ client.surname }}</span>&nbsp;

                                <a class="badge text-black-50" :href="'mailto:' + client.email_01"
                                   v-if="!!client.email_01">
                                    <i class="uq-icon bi-mailbox"></i>&nbsp;{{ client.email_01 }}
                                </a>
                                <a class="badge text-black-50" :href="'mailto:' + client.email_02"
                                   v-if="!!client.email_02">
                                    <i class="uq-icon bi-mailbox"></i>&nbsp;{{ client.email_02 }}
                                </a>
                                <a class="badge text-black-50" :href="'tel:' + client.phone_number_01"
                                   v-if="!!client.phone_number_01">
                                    <i class="uq-icon bi-phone"></i>&nbsp;{{ client.phone_number_01 }}
                                </a>
                                <a class="badge text-black-50" :href="'tel:' + client.phone_number_02"
                                   v-if="!!client.phone_number_02">
                                    <i class="uq-icon bi-phone"></i>&nbsp;{{ client.phone_number_02 }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import router from "../../../router";
import {createExpedient, getContractTypes} from "../../../helpers/requests/RequestsExpedients";
import {
    getAllEntitiesWithoutPagination,
    getEntities,
    getEntitiesWithoutPagination
} from "../../../helpers/requests/RequestsEntities";
import {
    getAllClientsWithoutPagination,
    getClients,
    getClientsWithoutPagination
} from "../../../helpers/requests/RequestsClients";

import VModalValidated from "../../general/VModalValidated";
import {ErrorMessage, Field, Form} from "vee-validate";
import * as yup from "yup";


import VSelectJq from "../../general/VSelectJQ";

export default {
    name: "ExpedientsListAddModal",
    components: {VModalValidated, Form, Field, ErrorMessage, VSelectJq},
    props: {
        preselected_client: {
            type: String,
            required: false,
        },
        preselected_entity: {
            type: String,
            required: false,
        }
    },
    data() {
        return {
            expedient: {
                responsible: 'atencion_al_cliente',
                contract_type: 'mortgage',
            },
            clients: [],
            entities: [],
            client: null,
            entity: null,
            allFields: [],

            contractTypes: [],

            entitiesOptions: [],
            clientsOptions: [],

            rules: {
                name: yup.string().required('Debes incluir un nombre').max(50, 'Debe tener como máximo 50 caracteres'),
                contract_type: yup.string().required('Debes seleccionar un tipo de contrato'),
                client_id: yup.string().required('Debes seleccionar un cliente'),
                entity_id: yup.string().required('Debes seleccionar una entidad'),
            }
        }
    },

    async mounted() {
        // TODO: Pass clients and entities from props or request when loaded (?)
        await Promise.all([
            this.loadClients(),
            this.loadEntities(),
            this.loadContractTypes(),
        ]);

        // TODO: Please, refactor all this component: do not go through all models everytime, select and if selected show info
        if (!!this.preselected_client) {
            this.expedient.client_id = parseInt(this.preselected_client);
            for (let i in this.clients) {
                if (this.clients[i].id === this.expedient.client_id) {
                    this.client = this.clients[i];
                    break;
                }
            }
        }

        if (!!this.preselected_entity) {
            this.expedient.entity_id = parseInt(this.preselected_entity);
            for (let i in this.entities) {
                if (this.entities[i].id === this.expedient.entity_id) {
                    this.entity = this.entities[i];
                    break;
                }
            }
        }

        this.allFields = require('../../../config/form_fields.json').clients;
    },
    methods: {
        async loadClients() {
            let clients = await getAllClientsWithoutPagination();

            if (!clients.meta) {
                this.clients = clients;

                this.clientsOptions = Object.values(clients).map((client) => {
                    return {id: client.id, text: client.fullName}
                });
            }
        },
        async loadEntities() {
            let entities = await getAllEntitiesWithoutPagination();
            if (!entities.meta) {
                this.entities = entities;

                this.entitiesOptions = Object.values(entities).map((entity) => {
                    return {id: entity.id, text: entity.name + ' (' + entity.short_name + ')'};
                });
            }
        },
        async loadContractTypes() {
            this.contractTypes = await getContractTypes();
        },
        async addExpedient(data) {
            try {
                let res = await createExpedient(data.name, data.entity_id, data.client_id, data.contract_type, this.expedient.responsible);

                this.$store.dispatch('app/setToastMessage', 'Expediente añadido con éxito');

                this.expedient.name = '';
                this.client = null;
                this.entity = null;
                this.expedient.responsible = 'atencion_al_cliente';
                this.expedient.contract_type = 'mortgage';

                this.$emit('expedient-created');
            } catch (e) {
                let error_message = e.response.data.message;
                this.$store.dispatch('app/setErrorToastMessage', error_message ?? 'Error al crear el expediente');

                this.closeModal();
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    },
}
</script>
